var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74092 7.61421C9.53985 7.81529 9.22345 7.83076 9.00464 7.66062L8.95209 7.61421L5.99976 4.66232L3.04743 7.61421C2.84635 7.81529 2.52995 7.83076 2.31114 7.66062L2.25859 7.61421C2.05751 7.41314 2.04205 7.09674 2.21219 6.87793L2.25859 6.82538L5.60534 3.47863C5.80641 3.27755 6.12281 3.26209 6.34163 3.43223L6.39417 3.47863L9.74092 6.82538C9.95875 7.04321 9.95875 7.39638 9.74092 7.61421Z",
    fill: "#1C3775"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.68e496d9d89ce364d807362fb58d5d25.svg";
export { ForwardRef as ReactComponent };